module.exports = __webpack_public_path__ + "static/evento-um-2020-register-now-0ac03bf09c1e21fc779d04c7e04caf55.png";